/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import Div from "@jumbo/shared/Div";
import { useDispatch, useSelector } from "react-redux";
import { markModuleRead, fetchUnreadCount } from "app/redux/slice/notificationSlice";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import { userType } from "app/helpers/userType";
import { useNavigate } from "react-router-dom";
import { MILL_ORDER_ADD, millOrderEdit } from "app/routes/constant";
import ChangeStatus from "./dialog/change-status";
import DonutLargeIcon from "@mui/icons-material/DonutLarge";
import {
  deleteMillOrder,
  getMillOrderList,
  updateMillOrderStatus,
} from "app/redux/slice/millOrderSlice";
import { getSupplierList } from "app/redux/slice/supplierSlice";
import moment from "moment";
import Span from "@jumbo/shared/Span";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FilePreview from "./dialog/file-preview";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";

const Order = () => {
  const navigate = useNavigate();

  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();
  const [status, setStatus] = useState("All");

  const millOrderData = useSelector((state) => state?.millOrder);
  const supplierData = useSelector((state) => state?.supplier);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [supplierId, setSupplierId] = useState();

  const {
    isOpen: isOpenOrderStatus,
    onClose: closeOrderStatus,
    actionProps: orderStatusActionProps,
    stageAction: changeStatusStageAction,
  } = useDisclosure();

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const {
    isOpen: isOpenFilePreview,
    onClose: closeFilePreview,
    actionProps: filePreviewActionProps,
    stageAction: filePreviewStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "millOrder" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    changeStatusPermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        changeStatusPermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        changeStatusPermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData?.filter((item) => {
        return item?.moduleName?.includes("Mill Order") && item;
      });
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-mill-order") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-mill-order") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-mill-order") {
            permissionValue.updatePermission = true;
          }
          if (num?.name === "manage-status-mill-order") {
            permissionValue.changeStatusPermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    {
      id: "date",
      label: "Date",
      sort: true,
      minWidth: 95,
      render: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    { id: "orderNo", label: "Order No.", sort: true, minWidth: 110 },
    {
      label: "Fabric Name",
      sort: false,
      minWidth: 100,
      render: (row) =>
        row?.products?.length
          ? `${row?.products?.[0]?.productId?.name} (${row?.products?.[0]?.variantId?.name})`
          : " - ",
    },
    {
      id: "gpNumber",
      label: "GP No.",
      sort: true,
      minWidth: 100,
      render: (row) => row?.gpNumber || " - ",
    },
    {
      id: "vendor",
      label: "Vendor Name",
      minWidth: 140,
      render: (row) => row?.supplierId?.name,
    },
    {
      id: "lotNumber",
      label: "Lot No.",
      sort: false,
      minWidth: 105,
      render: (row) => row?.millPurchaseId?.lotNumber,
    },
    {
      id: "partyChallan",
      label: "Party Challan",
      sort: false,
      minWidth: 105,
      render: (row) => row?.millPurchaseId?.knitterOrderId?.partyChallan,
    },
    {
      id: "status",
      label: "Status",
      sort: true,
      render: (row) =>
        row?.status === "Process" ? (
          <Span style={{ color: "red" }}>Process</Span>
        ) : row?.status === "Partial" ? (
          <Span style={{ color: "orange" }}>Partial</Span>
        ) : (
          <Span style={{ color: "green" }}>Complete</Span>
        ),
    },
    { id: "totalQuantity", label: "Qty", sort: true },
    {
      id: "remainingQty",
      label: "Rem.Qty",
      render: (row) => row?.products[0].remainingQty,
    },
    {
      id: "actions",
      label: "Actions",
      minWidth: 180,
      align: "center",
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.updatePermission}
            onClick={() => {
              stageAction(row);
              navigate(millOrderEdit(row._id));
            }}
          >
            <EditIcon />
          </IconButton>
          <Tooltip title="Change Status">
            <IconButton
              disabled={
                !permission.changeStatusPermission
                // // !permission.changeStatusPermission || row?.status === "Complete"
              }
              onClick={() => {
                changeStatusStageAction(row);
              }}
            >
              <DonutLargeIcon />
            </IconButton>
          </Tooltip>
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
          <IconButton
            onClick={() => {
              filePreviewStageAction(row);
            }}
          >
            <FolderOpenIcon />
          </IconButton>
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    const formData = new FormData();
    // formData.append("quantity", data?.quantity);
    formData.append("status", data?.status);
    data?.files?.forEach((file) => {
      formData.append("statusImage", file);
    });
    formData.append("variants", JSON.stringify(data.product));
    const response = await dispatch(
      updateMillOrderStatus({ id: data?.orderId, data: formData })
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      getData();
      closeOrderStatus();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
    closeOrderStatus();
  };

  const DeleteOrder = () => {
    closeDelete();
    dispatch(deleteMillOrder(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("mill-order-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(supplierId && { supplierId: supplierId?._id }),
      ...(status !== "All" && { status }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getMillOrderList(value));
    // Mark notifications as read whenever list is fetched
    dispatch(markModuleRead("Mill Order")).then(() => {
      dispatch(fetchUnreadCount("Mill Order"));
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0,0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  useEffect(() => {
    getPermission();
    dispatch(getSupplierList({ sort: 1, field: "name", type: "Mill" }));
  }, []);

  return (
    <>
      {millOrderData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <JumboAutoComplete
                      options={supplierData?.list || []}
                      label="Vendor"
                      size="small"
                      getOptionLabel={(option) => option?.name}
                      name={`supplierId`}
                      value={supplierId}
                      onChange={(evt, value) => setSupplierId(value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        id="status"
                        value={status}
                        label="status"
                        size="small"
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <MenuItem></MenuItem>
                        {["All", "Complete", "Process", "Partial"].map(
                          (val) => {
                            return <MenuItem value={val}>{val}</MenuItem>;
                          }
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0,0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Order List
                </Typography>
                {console.log({ permission })}
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      navigate(MILL_ORDER_ADD);
                    }}
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add Order
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={millOrderData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={millOrderData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          {permission.createPermission && (
            <DialogDefault
              open={isOpenOrderStatus}
              onClose={closeOrderStatus}
              content={
                <ChangeStatus
                  value={orderStatusActionProps}
                  onClose={closeOrderStatus}
                  handleSubmit={handleSubmit}
                />
              }
              title={"Change Order Status"}
              fullWidth={false}
              maxWidth={"lg"}
              actions={<></>}
            />
          )}
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the order?"
            onConfirm={DeleteOrder}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
          <DialogDefault
            open={isOpenFilePreview}
            onClose={closeFilePreview}
            content={
              <FilePreview
                value={filePreviewActionProps}
                onClose={closeFilePreview}
                handleSubmit={handleSubmit}
              />
            }
            title={"Files"}
            fullWidth={false}
            maxWidth={"lg"}
            actions={<></>}
          />
        </>
      )}
    </>
  );
};

export default Order;
